import vcMutilCheckbox from './src/vc-mutil-checkbox'

vcMutilCheckbox.install = function (Vue) {
  Vue.component(vcMutilCheckbox.name, vcMutilCheckbox)
}

export default vcMutilCheckbox
